module.exports = __webpack_public_path__ + "img/auth-status-passed-icon.6d71a088.svg";